import React, { useState, useRef, useEffect, useContext } from 'react';
import { TextField } from '@mui/material';
import InputMask from 'react-input-mask';
import { cvv } from "card-validator";
import { CreditCardDataContext } from './CreditCard';
import { absLenght } from './helpers/converters';
import CustomFormLabel from '../forms/custom-elements/CustomFormLabel';


//TODO: chnange to props
const CVCInput = ({leaveFieldCallback, focus, tabIndex}) => {
  const [error, setError] = useState(false);
  const [info, setInfo] = useState("");

  const CardContext = useContext(CreditCardDataContext);
  const inputRef = useRef(null);
  const CVCLengthRequired = CardContext?.cardData?.cvclenght;


  const handleChange = (event) => {
    
    const CVCLength = absLenght(inputRef?.current.value);
    const CVCverify = cvv(event?.target?.value);

    if(CVCLength > 0 && CVCLength!== CVCLengthRequired) {
      setError(true);
      setInfo("Incorect CVC length");
    } else if (CVCLength > 0 && !CVCverify.isPotentiallyValid) {
      setError(true);
      setInfo("Dont now what but something sticky");
    } else if (CVCverify.isValid) {
      setError(false);
      setInfo("");
      if(leaveFieldCallback) {
        leaveFieldCallback(tabIndex + 1);
      }
    }
  }

  const handleBlur = (event) => {
    const CVCvalue = event?.target?.value;
    const CVCLength = absLenght(CVCvalue);
    const value = cvv(CVCvalue);
    if(CVCLength > 0 && value.isValid) {
      setError(false);
      setInfo("");
      CardContext?.setCardData({
        ...CardContext.cardData,
        cvc: CVCvalue
      });
    } else {
      //TODO: could rmove - its redundand
      setError(true);
      setInfo("Its not valid CVC code");
    }
  }

useEffect(() => {
  if(focus) {
    
  }
}, [focus])
//TODO: props cvc count i mask na to ustawić
  return (
    <>
    <CustomFormLabel style={{ margin: '5px' }}>CVC</CustomFormLabel>
    <InputMask
      mask="999"
      maskChar=" "
      onChange={handleChange}
      onBlur={handleBlur}
    >
    {() =>
      <TextField
      fullWidth
        size='small'
        variant='outlined'
        name="cvc"
        type="text"
        error={error}
        placeholder="XXX"
        tabIndex={tabIndex}
        required
        helperText={info}
        autoFocus={focus}
        inputRef={inputRef}
      />
    }
    </ InputMask>
    </>
  )
}

export default CVCInput;